import { SectionVerticalSlide } from "@/components";
import { Footer } from "@/components/layout/footer";
import { useGetBaseInfo, useGetSpecial, type BaseInfoResponse, type SpecialInfoResponse } from "@/shared/server";
import { Center, Spinner, Text } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { SpecialPreview, Travel } from "../common";
import { TopSection } from "../common/components/topSection";

export const Specials = () => {
    const { specialIdx } = useParams<string>();

    console.log(specialIdx);
    const option = { enabled: !!specialIdx };
    const { data: footerData } = useGetBaseInfo<BaseInfoResponse>();
    const { data } = useGetSpecial<SpecialInfoResponse>({ specialIdx: specialIdx ?? "" }, option);

    if (!specialIdx) {
        // 404로 요청
        return <div>404로 요청합니다</div>;
    }

    return data && footerData ? (
        <SectionVerticalSlide>
            <TopSection catchPraise={data.catchPraise} imgList={data.imgList} />
            <SpecialPreview />
            <Travel />
            <Footer
                isPrivate={footerData.isPrivate}
                logoUrl={footerData.logoUrl}
                pensionInfo={footerData.pensionInfo}
            />
        </SectionVerticalSlide>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
